// extracted by mini-css-extract-plugin
export var altFill = "AlmaLogo-module--altFill--sxayC";
export var inner = "AlmaLogo-module--inner--XwPrt";
export var svg = "AlmaLogo-module--svg--XgL5a";